import React, {useEffect, useRef, useState} from 'react'
import Slider from 'react-slick'
import {ChevronLeftIcon, ChevronRightIcon} from '@salesforce/retail-react-app/app/components/icons'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'

const SliderInitiator = ({slidesHtml, settings}) => {
    const [currentSlide, setCurrentSlide] = useState(0)
    const sliderRef = useRef(null)

    const sliderSettings = {
        nextArrow: <ChevronRightIcon aria-hidden={true} boxSize={5} />,
        prevArrow: (
            <ChevronLeftIcon
                aria-hidden={true}
                boxSize={5}
                visibility={settings.centerMode && currentSlide === 1 ? 'hidden' : 'visible'}
            />
        ),
        ...settings,
        beforeChange: (oldIndex, newIndex) => {
            if (settings.centerMode) {
                setCurrentSlide(newIndex)
            }
            if (settings.beforeChange) {
                settings.beforeChange(oldIndex, newIndex)
            }
        }
    }

    useEffect(() => {
        if (sliderRef.current && window && window.innerWidth >= 768 && settings.centerMode) {
            sliderRef.current.slickGoTo(1)
        }
    }, [sliderRef.current])

    return (
        <Box className="w-100">
            <Slider ref={sliderRef} {...sliderSettings}>
                {slidesHtml.map((slideHtml, index) => (
                    <Box key={index} dangerouslySetInnerHTML={{__html: slideHtml}} />
                ))}
            </Slider>
        </Box>
    )
}

// Add prop validation
SliderInitiator.propTypes = {
    slidesHtml: PropTypes.arrayOf(PropTypes.string).isRequired,
    settings: PropTypes.object.isRequired
}

export default SliderInitiator
